import * as React from "react";
const SvgNewTab20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 21 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M19.498.996h-5.746v2h2.323L11.27 7.802l1.414 1.414 4.815-4.815v2.37h2V.995Z"
    }),
    React.createElement("path", {
      fill: "current",
      d: "M9.559 1H1.5v18h18v-8.06h-2V17h-14V3h6.059V1Z"
    })
  );
export default SvgNewTab20Px;
